import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { PageHeader } from '../common'
import SessionSchedulingCalendar from './SessionSchedulingCalendar'

const FirstSessionSchedule = () => {
  const history = useHistory()
  const location = useLocation()
  const coachDetails = location.state?.coachDetails

  const renderHelmet = () => (
    <Helmet>
      <title>{'Sessions-Details | Abroad'}</title>
      <meta name='title' content={'Sessions | Abroad'}></meta>
      <meta property='og:title' content={'Sessions | Abroad'}></meta>
      <meta property='twitter:title' content={'Sessions | Abroad'}></meta>
      <link
        rel='canonical'
        href={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/upcoming/first-session`}></link>
      <meta
        property='og:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/upcoming/first-session`}></meta>
      <meta
        property='twitter:url'
        content={`${process.env.REACT_APP_DOMAIN}/coaching/sessions/upcoming/first-session`}></meta>
    </Helmet>
  )

  const handleScheduleSuccess = (event) => {
    history.push('/coaching/sessions', {
      scheduledEvent: event,
    })
  }

  return (
    <>
      {renderHelmet()}
      <PageHeader
        title='Sessions'
        version='small'
        backArrowAction={() => history.push('/coaching/sessions')}
        showBackArrow={true}
      />
      <SessionSchedulingCalendar
        schedulingType='first-session'
        coachDetails={coachDetails}
        onScheduleSuccess={handleScheduleSuccess}
      />
    </>
  )
}

export default FirstSessionSchedule
